import { render } from "./DataIngestionAlertsEmpty.vue?vue&type=template&id=d41fbd3a&scoped=true"
const script = {}

import "./DataIngestionAlertsEmpty.vue?vue&type=style&index=0&id=d41fbd3a&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d41fbd3a"]])

export default __exports__